import { t } from "ttag";

export function isMongoDeviceId(value: string): boolean {
  return /^[a-fA-F0-9]{24}$/.test(value);
}

export function unknownEntitiesFromError(error: unknown): string[] {
  const message = formatSyncError(error, "");
  const match = message.match(/Unknown sync entities:\s*([^.]+)/i);
  if (!match) {
    return [];
  }
  return match[1]
    .split(/[,]+/)
    .map((item) => item.trim())
    .filter((item) => /^[A-Za-z][A-Za-z0-9]*$/.test(item));
}

export function formatSyncError(error: unknown, fallback: string): string {
  if (typeof error === "string" && error.trim()) {
    return error.trim();
  }

  const err = error as {
    message?: unknown;
    error?: unknown;
    data?: { message?: unknown; error?: unknown };
  } | null;

  const candidates = [
    err?.message,
    err?.error,
    err?.data?.message,
    err?.data?.error
  ];

  for (const candidate of candidates) {
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate.trim();
    }
  }

  return fallback;
}

export function formatSyncOutcome(
  label: string,
  action: "push" | "pull",
  ok: boolean
): string {
  const direction = action === "push" ? t`cloud → device` : t`device → cloud`;
  if (ok) {
    return t`${label} sync succeeded (${direction}).`;
  }
  return t`${label} sync failed (${direction}).`;
}

export function formatBatchSyncOutcome(ok: number, fail: number): string {
  if (fail === 0) {
    return ok === 1 ? t`Synced 1 entity.` : t`Synced ${ok} entities.`;
  }
  if (ok === 0) {
    return fail === 1 ? t`Sync failed for 1 entity.` : t`Sync failed for ${fail} entities.`;
  }
  return t`Synced ${ok}, failed ${fail}.`;
}
